import { FACTORS_TO_SHOW } from "@app/service/user";

export const VERIFY_2FA_PHONE_CALL_CODE_MIN_LENGTH = 5;
export const VERIFY_2FA_CODE_MIN_LENGTH = 6;

export const verifyCodeLength = (type: FACTORS_TO_SHOW): number =>
  type === FACTORS_TO_SHOW.call
    ? VERIFY_2FA_PHONE_CALL_CODE_MIN_LENGTH
    : VERIFY_2FA_CODE_MIN_LENGTH;
